module.exports = __webpack_public_path__ + "img/banner.a6778b55.png";